/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CheckEmailOptedOut200Response,
  CreateEmailOptOut200Response,
} from '../models/index';
import {
    CheckEmailOptedOut200ResponseFromJSON,
    CheckEmailOptedOut200ResponseToJSON,
    CreateEmailOptOut200ResponseFromJSON,
    CreateEmailOptOut200ResponseToJSON,
} from '../models/index';

export interface CheckEmailOptedOutRequest {
    endpoint: string;
}

export interface CreateEmailOptOutRequest {
    endpoint: string;
}

export interface DeleteEmailOptOutRequest {
    endpoint: string;
}

/**
 * 
 */
export class GlobalOptOutsApi extends runtime.BaseAPI {

    /**
     * Check email opted out
     * Check Email Opted Out
     */
    async checkEmailOptedOutRaw(requestParameters: CheckEmailOptedOutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CheckEmailOptedOut200Response>> {
        if (requestParameters['endpoint'] == null) {
            throw new runtime.RequiredError(
                'endpoint',
                'Required parameter "endpoint" was null or undefined when calling checkEmailOptedOut().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['endpoint'] != null) {
            queryParameters['endpoint'] = requestParameters['endpoint'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/global-opt-out`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CheckEmailOptedOut200ResponseFromJSON(jsonValue));
    }

    /**
     * Check email opted out
     * Check Email Opted Out
     */
    async checkEmailOptedOut(requestParameters: CheckEmailOptedOutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CheckEmailOptedOut200Response> {
        const response = await this.checkEmailOptedOutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create email opt out
     * Create Email Opt Out
     */
    async createEmailOptOutRaw(requestParameters: CreateEmailOptOutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateEmailOptOut200Response>> {
        if (requestParameters['endpoint'] == null) {
            throw new runtime.RequiredError(
                'endpoint',
                'Required parameter "endpoint" was null or undefined when calling createEmailOptOut().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['endpoint'] != null) {
            queryParameters['endpoint'] = requestParameters['endpoint'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/global-opt-out/email`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateEmailOptOut200ResponseFromJSON(jsonValue));
    }

    /**
     * Create email opt out
     * Create Email Opt Out
     */
    async createEmailOptOut(requestParameters: CreateEmailOptOutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateEmailOptOut200Response> {
        const response = await this.createEmailOptOutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete email opt out
     * Delete Email Opt Out
     */
    async deleteEmailOptOutRaw(requestParameters: DeleteEmailOptOutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateEmailOptOut200Response>> {
        if (requestParameters['endpoint'] == null) {
            throw new runtime.RequiredError(
                'endpoint',
                'Required parameter "endpoint" was null or undefined when calling deleteEmailOptOut().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['endpoint'] != null) {
            queryParameters['endpoint'] = requestParameters['endpoint'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/global-opt-out/email`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateEmailOptOut200ResponseFromJSON(jsonValue));
    }

    /**
     * Delete email opt out
     * Delete Email Opt Out
     */
    async deleteEmailOptOut(requestParameters: DeleteEmailOptOutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateEmailOptOut200Response> {
        const response = await this.deleteEmailOptOutRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
